/**
 * Purpose of Use code constants for TEFCA and Carequality governance
 * Sourced from Kno2.IHE.Utils.Services.PouCodes
 */

/** TEFCA Purpose of Use codes */
export enum TEFCAPurposeOfUseCode {
    /** TEFCA Required Treatment */
    TRTMNT = "T-TRTMNT",
    /** Treatment */
    TREAT = "T-TREAT",
    /** Payment */
    PYMNT = "T-PYMNT",
    /** Public Health */
    PH = "T-PH",
    /** Electronic Case Reporting */
    PHECR = "T-PH-ECR",
    /** Electronic Lab Reporting */
    PHELR = "T-PH-ELR",
    /** Individual Access Services */
    IAS = "T-IAS",
    /** Government Benefits Determination */
    GOVDTRM = "T-GOVDTRM"
}

/** TEFCA Health Care Operations Purpose of Use codes */
export enum TEFCAHealthCareOperationsPurposeOfUseCode {
    /** Health Care Operations */
    HCO = "T-HCO",
    /** Care Coordination/Case Management */
    HCOCC = "T-HCO-CC",
    /** HEDIS Reporting */
    HCOHED = "T-HCO-HED",
    /** Quality Assessment and Improvement */
    HCOQAI = "T-HCO-QAI",
    /** Population-Based Activities */
    HCOPOP = "T-HCO-POP",
    /** Patient Safety */
    HCOPTSAFETY = "T-HCO-PTSAFETY",
    /** Performance Review */
    HCOPERF = "T-HCO-PERF"
}

/** Carequality Purpose of Use codes */
export enum CarequalityPurposeOfUseCode {
    /** Treatment */
    TREATMENT = "TREATMENT",
    /** Payment */
    PAYMENT = "PAYMENT",
    /** Health Care Operations */
    OPERATIONS = "OPERATIONS",
    /** Public Health */
    PUBLICHEALTH = "PUBLICHEALTH",
    /** Individual Access Services */
    REQUEST = "REQUEST",
    /** Government Benefits Determination */
    COVERAGE = "COVERAGE",
    /** Care Coordination */
    CARECOORDINATION = "CARECOORDINATION"
}
